$(function () {
    // Sticky Header
    const header = document.getElementById('header')
    const trigger = document.getElementById('sticky-trigger')

    const observer = new IntersectionObserver(
        function (entries) {
            if (!entries[0].isIntersecting) {
                header.classList.add('sticky')
            } else {
                header.classList.remove('sticky')
            }
        },
        {
            root: null, // viewport
            threshold: 0,
        }
    )

    if (trigger) {
        observer.observe(trigger)
    }

    // Submenu
    const $items = $('.nav-menu .menu-item-has-children')

    function isMobile() {
        return window.innerWidth < 992
    }

    $items.each(function () {
        const $item = $(this)

        $item.children('.nav-link').on('click', function (e) {
            if (isMobile()) {
                if ($item.find('.sub-menu').length > 0) {
                    e.preventDefault()
                    $items.not($item).removeClass('show-submenu')
                    $item.toggleClass('show-submenu')
                }
            }
        })
    })

    $(document).on('click', function (e) {
        if (isMobile()) {
            if (!$(e.target).closest('.menu-item-has-children').length) {
                $items.removeClass('show-submenu')
            }
        }
    })

    $(window).on('resize', function () {
        if (!isMobile()) {
            $items.removeClass('show-submenu')
        }
    })

    // Accessibility Features
    initAccessibilityFeatures()

    // Masks
    var maskBehavior = function (val) {
            return val.replace(/\D/g, '').length === 11
                ? '(00) 00000-0000'
                : '(00) 0000-00009'
        },
        options = {
            onKeyPress: function (val, e, field, options) {
                field.mask(maskBehavior.apply({}, arguments), options)
            },
        }
    $('.form-tel').mask(maskBehavior, options)
    $('.form-cep').mask('00000-000')
    $('.form-cpf').mask('000.000.000-00')
    $('.form-cnpj').mask('00.000.000/0000-00')

    // Floating Labels in CF7
    var formControls = document.querySelectorAll(
        '.wpcf7 .form-control, .wpcf7 .form-select'
    )

    for (var i = 0; i < formControls.length; i++) {
        var input = formControls[i]
        var label = input.parentNode.parentNode.querySelector('label')

        input.addEventListener('focus', function () {
            this.parentNode.parentNode.classList.add('active')
        })

        input.addEventListener('blur', function () {
            var cval = this.value
            if (cval.length < 1) {
                this.parentNode.parentNode.classList.remove('active')
            }
        })

        if (label) {
            label.addEventListener('click', function () {
                var input = this.parentNode.querySelector(
                    '.form-control, .form-select'
                )
                input.focus()
            })
        }
    }

    $('.form-select').each(function () {
        const $select = $(this)
        const $group = $select.closest('.form-group')

        if ($select.val()) {
            $group.addClass('active')
        }

        $select.on('change', function () {
            if ($(this).val()) {
                $group.addClass('active')
            } else {
                $group.removeClass('active')
            }
        })
    })

    // Get container offset
    offsetWidth()
    $(window).on('resize', function () {
        offsetWidth()
    })

    function offsetWidth() {
        var containerOffset = $('.container').offset().left
        $('.container-offset').css('width', containerOffset)
        $('.container-offset-left').css('padding-left', containerOffset)
        $('.container-offset-right').css('padding-right', containerOffset)
    }

    // Smooth Scrolling to Anchor Links
    $('.smooth-scroll').bind('click', function (event) {
        var $anchor = $(this)

        $('html, body')
            .stop()
            .animate(
                {
                    scrollTop: $($anchor.attr('href')).offset().top - 300,
                },
                1000
            )

        event.preventDefault()
    })

    // Fancybox
    Fancybox.bind()

    // Aos
    //AOS.init()

    // To Top Button
    $(window).on('scroll', function () {
        var scrollTop = $(window).scrollTop()
        var limit = 400

        if (scrollTop >= limit) {
            $('#to-top').fadeIn()
        } else {
            $('#to-top').fadeOut()
        }
    })

    // Share
    function copyToClipboard(url) {
        if (navigator.clipboard) {
            return navigator.clipboard.writeText(url)
        } else {
            return new Promise((resolve, reject) => {
                const textArea = document.createElement('textarea')
                textArea.value = url
                textArea.style.position = 'fixed'
                textArea.style.opacity = '0'
                document.body.appendChild(textArea)
                textArea.select()

                try {
                    const successful = document.execCommand('copy')
                    document.body.removeChild(textArea)
                    if (successful) {
                        resolve()
                    } else {
                        reject(new Error('Comando de cópia falhou'))
                    }
                } catch (err) {
                    document.body.removeChild(textArea)
                    reject(err)
                }
            })
        }
    }

    function showShareToast() {
        const toastElement = document.getElementById('shareToast')
        if (toastElement) {
            const toast = new bootstrap.Toast(toastElement)
            toast.show()
        }
    }

    $(document).on('click', '.share-button', function (e) {
        e.preventDefault()
        const url = $(this).data('url')

        copyToClipboard(url)
            .then(() => showShareToast())
            .catch((err) => console.error('Erro ao copiar:', err))
    })

    // Fitty
    fitty('.fitty-text', {
        minSize: 60,
        maxSize: 300,
    })

    if(localStorage.getItem('avisoLGPD') != 'aceitou_aviso'){
        jQuery(".aceitar_cookies").fadeIn();
    }

    jQuery('.aceitar_cookies_bt').click(function(e){
        jQuery('.aceitar_cookies').fadeOut();
        localStorage.setItem('avisoLGPD','aceitou_aviso');
    });
})

function initAccessibilityFeatures() {
    var currentFontSize = 1
    var minFontSize = 0.8
    var maxFontSize = 1.5
    var contrastMode = 0

    // Keyboard navigation for accessibility links (Alt + 1, Alt + 2, Alt + 3)
    $(document).on('keydown', function (e) {
        // Alt + shortcuts
        if (e.altKey) {
            // Usar keyCode como fallback para melhor compatibilidade
            var key = e.key || String.fromCharCode(e.keyCode)

            // keyCode: 49 = 1, 50 = 2, 51 = 3
            if (e.keyCode === 49 || key === '1') {
                e.preventDefault()
                var $link = $('[data-key="1"]')
                if ($link.length) {
                    $link[0].click()
                    $link.focus()
                }
            } else if (e.keyCode === 50 || key === '2') {
                e.preventDefault()
                // Toggle do menu offcanvas
                var menuElement = document.getElementById('menuDrawer')
                var menuDrawer =
                    bootstrap.Offcanvas.getOrCreateInstance(menuElement)

                // Verificar se está aberto antes do toggle
                var wasOpen = menuElement.classList.contains('show')

                menuDrawer.toggle()

                // Se estava fechado (agora vai abrir), focar no primeiro item
                if (!wasOpen) {
                    setTimeout(function () {
                        var firstNavLink = document.querySelector(
                            '#menuDrawer .nav-link'
                        )
                        if (firstNavLink) {
                            firstNavLink.focus()
                        }
                    }, 300)
                }
            } else if (e.keyCode === 51 || key === '3') {
                e.preventDefault()
                // Focar no campo de busca
                var searchInput = document.querySelector(
                    '#busca input[type="search"]'
                )
                if (searchInput) {
                    searchInput.focus()
                }
            } else if (key === '+' || key === '=' || e.keyCode === 187 || e.keyCode === 107) {
                e.preventDefault()
                zoomIn()
            } else if (key === '-' || e.keyCode === 189 || e.keyCode === 109) {
                e.preventDefault()
                zoomOut()
            } else if (key === 'c' || key === 'C' || e.keyCode === 67) {
                e.preventDefault()
                toggleContrast()
            }
        }
    })

    // Zoom In functionality
    function zoomIn() {
        if (currentFontSize < maxFontSize) {
            currentFontSize += 0.1
            $('html').css('font-size', currentFontSize + 'rem')
            localStorage.setItem('fontSize', currentFontSize)
        }
    }

    // Zoom Out functionality
    function zoomOut() {
        if (currentFontSize > minFontSize) {
            currentFontSize -= 0.1
            $('html').css('font-size', currentFontSize + 'rem')
            localStorage.setItem('fontSize', currentFontSize)
        }
    }

    // Toggle Contrast functionality (3 estados: normal, invertido, preto e branco)
    var contrastMode = 0 // 0 = normal, 1 = invertido, 2 = preto e branco

    function toggleContrast() {
        // Remover classes existentes
        $('body').removeClass('high-contrast grayscale-contrast')

        // Avançar para o próximo modo
        contrastMode = (contrastMode + 1) % 3

        // Aplicar classe baseada no modo
        switch (contrastMode) {
            case 1:
                $('body').addClass('high-contrast')
                break
            case 2:
                $('body').addClass('grayscale-contrast')
                break
            default:
                // Modo 0 (normal) - sem classes
                break
        }

        // Salvar no localStorage
        localStorage.setItem('contrastMode', contrastMode)

        // Recalcular offset após mudança de modo
        setTimeout(function () {
            offsetWidth()
        }, 50)
    }

    // Button event listeners
    $('#zoom-in').on('click', zoomIn)
    $('#zoom-out').on('click', zoomOut)
    $('#toggle-contrast').on('click', toggleContrast)

    // Load saved preferences
    var savedFontSize = localStorage.getItem('fontSize')
    var savedContrastMode = localStorage.getItem('contrastMode')

    if (savedFontSize) {
        currentFontSize = parseFloat(savedFontSize)
        $('html').css('font-size', currentFontSize + 'rem')
    }

    if (savedContrastMode) {
        contrastMode = parseInt(savedContrastMode)
        switch (contrastMode) {
            case 1:
                $('body').addClass('high-contrast')
                break
            case 2:
                $('body').addClass('grayscale-contrast')
                break
            default:
                contrastMode = 0
                break
        }
    }
}